import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useAccess } from '../../contexts/AccessContext';

/**
 * Réserve une page de l'espace admin aux personnes ayant le droit correspondant sur ce serveur.
 * Sans le droit : retour au tableau de bord du serveur (ou à l'espace membre si aucun droit).
 */
const RequirePermission = ({ permission, children }) => {
    const { serverId } = useParams();
    const { can, loading } = useAccess();

    if (loading) {
        return (
            <div className="c2-loading">
                <div className="c2-spinner" />
            </div>
        );
    }
    if (can(serverId, permission)) return children;
    return <Navigate to={can(serverId) ? `/server/${serverId}` : `/server/${serverId}/member`} replace />;
};

export default RequirePermission;
